import { DateTime } from 'luxon';

import type { ResolvedRangeDates } from './comparisonRanges';

/**
 * A resolved span with the year shown once when both dates are in the same calendar year,
 * for example `Jun 1 – Jun 30, 2026`. A span crossing years shows both years, and a single-day
 * span shows its one date, for example `Oct 26, 2026`.
 *
 * Returns `undefined` rather than a partial string when either end is unusable, so callers can fall
 * back to a label instead of rendering half a range. Shared between the popover's chips and the
 * trigger, which must format a custom range identically.
 */
export const formatSpan = (span: ResolvedRangeDates | undefined): string | undefined => {
  if (!span) return undefined;
  const start = DateTime.fromISO(span.startOn);
  const end = DateTime.fromISO(span.endOn);
  if (!start.isValid || !end.isValid) return undefined;
  if (start.hasSame(end, 'day')) return start.toFormat('MMM d, yyyy');
  const startFormat = start.hasSame(end, 'year') ? 'MMM d' : 'MMM d, yyyy';
  return `${start.toFormat(startFormat)} – ${end.toFormat('MMM d, yyyy')}`;
};
